import {  StandardDealerSingleOrderCreation} from "../implementations/standard-dealer/singleordercreation";
import StandardDealerStock from "../implementations/standard-dealer/stock";
import StandardDealerOrderHistory from "../implementations/standard-dealer/ordershistory";

const standardStockColumnOrder = [
    "SKU", "description", "avaibleQuantity", "reservedQuantity", "serialCode", "SORD", "BCNU",  "SCNU", "ownerCode",  "CNUM",  "dealerName", "dealerCode"
];

const standardStockFilterOrder = [
    "SKU", "description", "DELN", "SORD", "dealerCode", "SCNU", "SCNA",  "CNUM", "serialCode", "QuantityFilter", "filterButton",  "clearButton"
];


export const standardProfile = {
    code: "standard-dealer",
    pages: {
        orderCreation: StandardDealerSingleOrderCreation,
        stock: StandardDealerStock,
        orderHistory: StandardDealerOrderHistory
    },

    orderCreation: {
        components: {
            orderInfo: {
                enabled: true,
                props: {}
            },

            filters: {
                enabled: true,
                props: {
                    className: " no-last filter-panel-advanced",
                    order: standardStockFilterOrder
                }
            },

            stockTable: {
                enabled: true,
                props: {
                    columnOrder: standardStockColumnOrder
                }
            },

            orderOptions: {
                enabled: false,
                props: {
                    showOrderTypeSelector: false,
                    showCustomerPickup: false,
                    customerPickupLabel: "Ritiro cliente"
                }
            },

            addresses: {
                enabled: true,
                props: {}
            }
        }
    },

    stock: {
        components: {
            filters: {
                enabled: true,
                props: {
                    className: " no-last filter-panel-advanced",
                    order: standardStockFilterOrder,
                    advancedKeys: [
                        "DELN",
                        "SORD",
                        "dealerCode",
                        "SCNU",
                        "SCNA",
                        "CNUM",
                        "serialCode"
                    ]
                }
            },

            table: {
                enabled: true,
                props: {
                    columnOrder: standardStockColumnOrder
                }
            }
        }
    },

    orderHistory: {
        components: {
            filters: {
                enabled: true,
                props: {
                    order: [
                        "number",
                        "dealerCode",
                        "filterButton",
                        "clearButton"
                    ]
                }
            },

            table: {
                enabled: true,
                props: {
                    columnOrder: [
                        "displayNumber",
                        "date",
                        "shipmentReferenceID",
                        "deliveryName",
                        "carrierCode",
                        "status",
                        "dealerCode",
                        "actions"
                    ]
                }
            },

            details: {
                enabled: true,
                props: {
                    showAmount: false
                }
            }
        }
    },

    customizeHeaders(headers) {
        return headers;
    },

    customizeFilters(filters) {
        return filters;
    },

    customizeAdvancedFilterNames(names) {
        return names;
    },

    customizeOrderInfoConfig(config) {
        return config;
    },

    validateAdditional() {
        return {
            global: [],
            quantity: {},
            recipient: {},
            orderInfo: {}
        };
    },

    customizeStockRequest(data, filters) {
        return data;
    },

    isProvinceRequired(recipient = {}) {
        const country = String(recipient.country || "").trim().toUpperCase();

        return (country === "" ||  ["ITALIA", "ITALY", "IT"].includes(country));
    },

    getCarrierCode() {
        return "ITM";
    },

    orderLogic: {}
};